// src/utils/loadApiEndpoints.js (or wherever you placed it)
let apiEndpoints = null;

const loadApiEndpoints = async () => {
    if (apiEndpoints) return apiEndpoints;

    const response = await fetch("/apiendpoints.json");
    if (!response.ok) throw new Error("Failed to fetch API endpoints");
    apiEndpoints = await response.json();
    return apiEndpoints;
};
export default loadApiEndpoints;
